export const API = process.env.NODE_ENV === 'production' ? 'cocktail/delivery-app/server/public/' :'http://cocktail/delivery-app/server/public/',
             BASENAME =  process.env.NODE_ENV === 'production' ? '/menu' : '/';